import type { ReactNode } from 'react';
import React from 'react';
import clsx from 'clsx';
import { NextFutureImage } from '@components/main-components/image/NextFutureImage';
import { BackgroundBlur } from '../BackgroundBlur';

export const HERO_COVER_MOBILE_SIZE = 256;
export const HERO_COVER_SIZE = 358;

export const Hero = ({
  variant,
  withBlur = false,
  backgroundImageSrc,
  children,
  cover,
  details,
  isLoading = false,
}: {
  variant: 'artist' | 'collector' | 'playlist' | 'song' | 'songPreview';
  withBlur?: boolean;
  backgroundImageSrc?: string;
  cover?: ReactNode;
  details?: ReactNode;
  children?: ReactNode;
  isLoading?: boolean;
}) => {
  return (
    <div
      className={clsx('relative w-full', isLoading ? 'bg-base200' : 'bg-base800', {
        'h-[232px]  md:h-[300px]': variant === 'artist',
        'h-[386px] md:h-[300px]': variant == 'collector',
        'h-[443px] md:h-[500px]': variant === 'playlist',
        'h-[443px] md:h-[492px]': variant === 'song' || variant === 'songPreview',
      })}
    >
      {!isLoading && backgroundImageSrc && (
        <NextFutureImage
          className="object-cover object-center"
          fill
          src={backgroundImageSrc}
          alt="cover image"
          quality={withBlur ? 75 : 100}
          priority
        />
      )}
      {withBlur && <BackgroundBlur />}
      {(details || cover) && (
        <div
          className={clsx(
            'md:items-[unset] relative mx-auto flex h-full w-[296px] max-w-content flex-col-reverse items-center justify-center pt-16 md:h-auto md:w-full md:flex-row md:items-center md:justify-between md:gap-6 md:px-6',
            variant === 'collector'
              ? 'md:pt-28 lg:pt-[118px]'
              : variant === 'songPreview'
              ? 'md:pt-[70px]'
              : 'md:pt-[89px]',
          )}
        >
          <div className="min-w-0 max-w-full flex-1">
            <div
              className={clsx('flex h-full w-full items-center justify-center md:block md:h-auto', {
                'lg:w-4/5': !!cover,
              })}
            >
              {details}
            </div>
          </div>
          {cover && (
            <div
              className={clsx(
                'relative z-above1 flex-shrink-0',
                variant === 'collector'
                  ? 'h-[232px] w-[232px] lg:h-[296px] lg:w-[296px]'
                  : 'h-[256px] w-[256px] md:h-[358px] md:w-[358px]',
              )}
            >
              {cover}
            </div>
          )}
        </div>
      )}
      {children}
    </div>
  );
};
